import type { Page, ServiceItemInput, ServiceItemListQuery, ServiceItemView } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { toListParams } from '../../../../shared/policies/list-params';

export type { ServiceItemView };

export function listServiceItems(query: ServiceItemListQuery): Promise<Page<ServiceItemView>> {
  return api<Page<ServiceItemView>>(`/service-items?${toListParams(query)}`);
}

export function createServiceItem(input: ServiceItemInput): Promise<ServiceItemView> {
  return api<ServiceItemView>('/service-items', { method: 'POST', body: JSON.stringify(input) });
}

export function updateServiceItem(id: string, input: ServiceItemInput): Promise<ServiceItemView> {
  return api<ServiceItemView>(`/service-items/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function deactivateServiceItem(id: string): Promise<void> {
  await api<void>(`/service-items/${id}/deactivate`, { method: 'POST' });
}

export async function reactivateServiceItem(id: string): Promise<void> {
  await api<void>(`/service-items/${id}/reactivate`, { method: 'POST' });
}
